import { apiRequest } from '../client'
import type {
  AuthResponse,
  MeResponse,
  UpdatePreferencesRequest,
  UpdatePreferencesResponse,
} from '../types'

export const authApi = {
  login: (email: string, password: string) =>
    apiRequest<AuthResponse>('/api/auth/token', {
      method: 'POST',
      skipAuth: true, // Don't send Authorization header for login
      body: JSON.stringify({
        email,
        password,
        audience: 'admin', // Required for staff JWT
      }),
    }),

  refresh: (refreshToken: string) =>
    apiRequest<AuthResponse>('/api/auth/refresh', {
      method: 'POST',
      skipAuth: true, // Don't send Authorization header for refresh
      body: JSON.stringify({ refreshToken }),
    }),

  me: () => apiRequest<MeResponse>('/api/v0/admin/me'),

  updatePreferences: (preferences: UpdatePreferencesRequest) =>
    apiRequest<UpdatePreferencesResponse>('/api/v0/admin/me/preferences', {
      method: 'PATCH',
      body: JSON.stringify(preferences),
    }),
}
